import type { FaireProductEntity } from "../../entity_types/product";

export const p_rwtv5fy64x: FaireProductEntity = {
  token: "p_rwtv5fy64x",
  type: "product",
  name: "Rufia - Butterfly & Rose Sheer Crew Socks",
  brandToken: "b_qrthtbpuwu",
  brandName: "Funkyrel® Atzbranding Limited",
  imageUrl:
    "https://cdn.faire.com/fastly/f261636a7a019e416c7e7fd974dff1ed1361ae5c0416be03ae3b2bc0d032eb29.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/291e89456367d1148c934abc055a2ff5219be5135387598e22d116d402f40fdf.jpeg",
    "https://cdn.faire.com/fastly/d3e055d84bdebc800969f63bbe9e2da036a2298f4af30a3c55f3ad729f3d31df.jpeg",
    "https://cdn.faire.com/fastly/83fd198e406b9a1bf33d3ac8ccf2dfbdb5c2564a5cd52b68ce18af9f8e2d569e.jpeg",
    "https://cdn.faire.com/fastly/def77270f6fa3bd502d61c6089c5271170c239a40938381eb39acdd3e9b025af.jpeg",
    "https://cdn.faire.com/fastly/0043791515589de01207390cedaee8425aebaf5c7d5d509812c83e0b29648e6a.jpeg",
    "https://cdn.faire.com/fastly/1a09539fe1f10f6e4b076969ac2d17764522368e3f0f8911dad06e053bfe4711.jpeg",
    "https://cdn.faire.com/fastly/36109a33a916b47639fe0026c62d190dec2945c7433fb3ce3b86cb280aa9f2e4.jpeg",
    "https://cdn.faire.com/fastly/6c5deed82c6b8a32daacd0318d42e9650f6798ae9134c0d8384a0e18c4f3cffe.jpeg",
    "https://cdn.faire.com/fastly/383006c50ff7ffb6b2902bc90e8ee96485894c5f56337fb6fd946c60ce191b75.jpeg",
    "https://cdn.faire.com/fastly/7eca2ef93f831fb311bb0b360fc358c43de2bfa38fb5700c5f52fe3b7ae4e270.jpeg",
    "https://cdn.faire.com/fastly/9fb6b064a7cfb30221b4da9d39f357c7bed2070555e17ae0457eaaa215635d94.jpeg",
  ],
  priceDollars: 3,
  description:
    "Elevate spring and summer looks with Rufia — sheer crew socks that pair roses and playful butterflies for visible styling. Lightweight polyester gives a barely-there mid-calf layer that adds subtle texture and charm.\n\n• Sheer crew socks with floral butterfly print; 30g polyester.\n• Mid-calf crew fit for layered looks and statement socks styling.\n• Breathable for spring/summer; pairs with skirts, sandals, or cropped jeans.\n• Easy on/off with gentle stretch for a comfortable fit.\nSize: Women 5–10.\n\nShop Rufia to add instant flair and visible styling to everyday outfits — wear as butterfly crew socks or rose sheer socks to create memorable looks.\n\n𝐅𝐀𝐐\n\n• Q: Are these truly sheer? A: Yes — a lightweight sheer finish offers subtle coverage while highlighting the floral detail.\n• Q: What are they made of? A: Polyester, 30g — breathable and suited for warmer seasons.\n• Q: How can I style them? A: Pair as statement socks with skirts, cropped jeans, or layer under boots to let the pattern show.\nThis product is individually packaged in a polybag. All Funkyrel Atzbranding Products include a hangtag that displays the Funkyrel Atzbranding logo and UPC barcode.",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:43.569Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
